import React, { PropTypes } from 'react';


CloseX.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

CloseX.defaultProps = {
  style: {}
};

export default function CloseX(props) {
  const {
    className,
    style: {
      color,
      fill,
      strokeWidth,
      ... otherStyle
    },
    ... otherProps
  } = props;

  return (
    <svg className={`close-x ${className}`} style={otherStyle} width='8px' height='8px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' {...otherProps}>
      <g transform='translate(-1170.000000, -1184.000000)' stroke={fill || color || '#777777'} strokeWidth={(strokeWidth && `${strokeWidth}`) || '3'}>
        <g transform='translate(1171.000000, 1185.000000)'>
          <path d='M8,8 L0,0'></path>
          <path d='M8,0 L0,8'></path>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./shared/common/svgs/CloseX/index.js